import { useState, useEffect } from "react";
import "./App.css";

function HomePage() {
 const [size, setSize] = useState({
    width: window.innerWidth - 15,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth - 15,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const embedUrl =
    "https://app.powerbi.com/view?r=eyJrIjoiNTcwMGYwYzgtZjIzMS00OGM1LThiZmEtN2NhM2RjNDA0YzZlIiwidCI6IjQ1YTBmNjI4LTJhOWYtNGE0Ny05ODQ5LTQwYjM4NjllNzk3YSIsImMiOjl9";
  return (
    <>
      <iframe
        title="Online Scheduled Chemicals"
        width={size.width}
        height={size.height}
        src={embedUrl}
        frameBorder="0"
        allowFullScreen={true}
      ></iframe>
    </>
  );
}


export default HomePage;